import { getPublicSiteOrigin } from './get-public-site-origin';

export const getPublicOgImage = (): null | string => {
  const path = process.env.REACT_APP_PUBLIC_OG_IMAGE_PATH;
  if (!path) {
    return null;
  }
  const origin = getPublicSiteOrigin();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${origin}${normalized}`;
};
